import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function ImpressumPage() {
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-558">
      <Navigation data-id="element-559" />
      <main className="pt-24 pb-16" data-id="element-560">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-561">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-562">Impressum</h1>

          <div className="prose prose-invert max-w-none" data-id="element-563">
            <section className="mb-8" data-id="element-564">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-565">
                Adresse
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-566">
                CRM Kraft LLC
                <br data-id="element-567" />
                2880 West Oakland Park Boulevard
                <br data-id="element-568" />
                33311 Florida United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-569">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-570">
                Kontakt
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-571">
                Telefon: +4915735999071
                <br data-id="element-572" />
                E-Mail: justus@crm-kraft.de
              </p>
            </section>

            <section className="mb-8" data-id="element-573">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-574">
                EU-Streitschlichtung
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-575">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-576">
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br data-id="element-577" />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section data-id="element-578">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-579">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-580">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-581" />
    </div>;
}